import * as React from 'react';

import type { CompanyViewModel } from 'ab-viewModels/company.viewModel';

import CompanyFeatureFlagsEnum, { CompanyFeatureFlagsTips } from 'ab-enums/companyFeatureFlags.enum';

import PreviewItem from '../../Shared/PreviewItem';
import SettingPreview from '../../Shared/SettingPreview';

interface Props {
	toggleEdit: () => void;
	company: CompanyViewModel;
}

const CompanyWaiverSettingsPreview: React.FC<Props> = (props) => {
	const { toggleEdit, company } = props;
	const { companyWaiverStatus } = company;

	return (
		<SettingPreview toggleEdit={toggleEdit}>
			<div className="company-settings__info-segment">
				<PreviewItem
					checked={!!companyWaiverStatus}
					hint={CompanyFeatureFlagsTips.waiverSettings}
					indent={false}
					label={CompanyFeatureFlagsEnum.waiverSettings}
					showCheckbox={true}
				/>
			</div>
		</SettingPreview>
	);
};

export default React.memo(CompanyWaiverSettingsPreview);
